import { render, staticRenderFns } from "./UpdateBot.vue?vue&type=template&id=3de133d3&"
import script from "./UpdateBot.vue?vue&type=script&lang=js&"
export * from "./UpdateBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports